import { guid } from '@suite/shared';
import { AccessRights } from './access-rights.model';
import { UserPrivilege } from './user-privilege.model';

export class User implements UserInterface {
  id: number;
  firstName: string;
  lastName: string;
  company: string;
  email: string;
  phoneNumber: number;
  avatarUrl: string;
  validFrom: number;
  validTo: number;
  privileges: UserPrivilege[];

  constructor(entity: UserEntity) {
    this.id = entity.id;
    this.firstName = entity.firstName;
    this.lastName = entity.lastName;
    this.company = entity.company;
    this.email = entity.email;
    this.phoneNumber = entity.phoneNumber;
    this.avatarUrl = entity.avatarUrl;
    this.validFrom = entity.validFrom;
    this.validTo = entity.validTo;
    this.privileges = entity.privileges;
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }
}

export type UserInterface = UserEntity & {
  fullName: string;
};

export type UserEntity = {
  id: number;
  firstName: string;
  lastName: string;
  company: string;
  email: string;
  phoneNumber: number;
  avatarUrl: string;
  validFrom: number;
  validTo: number;
  privileges: UserPrivilege[];
};

export type UserV2Data = {
  id: guid;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string | null;
  company: string;
  avatarUrl: string | null;
  validFrom: Date;
  validTo: Date | null;
  accessRights: AccessRights;
};

export class UserV2 {
  id: guid;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string | null;
  company: string;
  avatarUrl: string | null;
  validFrom: Date;
  validTo: Date | null;
  accessRights: AccessRights;

  constructor(data: UserV2Data) {
    this.id = data.id;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.email = data.email;
    this.phoneNumber = data.phoneNumber;
    this.company = data.company;
    this.avatarUrl = data.avatarUrl;
    this.validFrom = data.validFrom;
    this.validTo = data.validTo;
    this.accessRights = data.accessRights;
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }
}

export type UserListItemData = {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string | null;
  company: string;
  avatarUrl: string | null;
  validFrom: Date;
  validTo: Date | null;
  active: boolean;
};

export class UserListItem {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string | null;
  company: string;
  avatarUrl: string | null;
  validFrom: Date;
  validTo: Date | null;
  active: boolean;

  constructor(data: UserListItemData) {
    this.id = data.id;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.email = data.email;
    this.phoneNumber = data.phoneNumber;
    this.company = data.company;
    this.avatarUrl = data.avatarUrl;
    this.validFrom = data.validFrom;
    this.validTo = data.validTo;
    this.active = data.active;
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }
}
